import React, { HTMLAttributes } from 'react'
import { TextThemeType } from '../../_config/types'
import { getThemedText } from '../../_common/functions'

interface ButtonProps extends HTMLAttributes<HTMLParagraphElement> {
    theme?: TextThemeType
    className?: string
}

const P: React.FC<ButtonProps> = ({ children, theme = '', className = '', ...args }) => {
    return (
        <p className={`${getThemedText(theme)} text-[1rem] leading-[1.5rem] mb-[0.833rem] ${className}`} {...args}>
            {children}
        </p>
    )
}

export default P
